import BrandMaster from "components/pages/brand/BrandMaster";
import CuisineMaster from "components/pages/cuisine/CuisineMaster";
import IngredientMaster from "components/pages/ingredient/IngredientMaster";
import ItemMaster from "components/pages/item/ItemMaster";
import Login from "components/pages/Login";
import RestaurantMaster from "components/pages/restaurant/RestaurantMaster";
import RestuaurantEmployeeMaster from "components/pages/restaurant/employee/RestuaurantEmployeeMaster";
import UnitOfMeasurementMaster from "components/pages/unitOfMeasurement/UnitOfMeasurementMaster";
import UserAdminMaster from "components/pages/user/admin/UserAdminMaster";
import React, { useEffect } from "react";
import { Navbar } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { LOGOUT } from "reducer/actions";
import RoutesMaster from "components/pages/RoutesMaster";
import OtpMaster from "components/pages/otp/OtpMaster";
import ViewPdf from "components/pages/view-pdf/ViewPdf";

const AppRoutes = () => {
  const { isAuthenticated, user } = useSelector((state) => state.user);
  const userRole = user?.userType || "";
  let location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isAuthenticated) {
      dispatch({ type: LOGOUT });
      navigate("/login");
    } else {
      const currentPath = location.pathname;
      if (currentPath === "/login") {
        navigate("/");
      }
    }
  }, [isAuthenticated]);

  return (
    <Routes>
      {!isAuthenticated ? (
        <Route path="/login" element={isAuthenticated ? <Navigate to={-1} /> : <Login />} />
      ) : (
        <Route path="/" element={<RoutesMaster />}>
          {(userRole && userRole !== "ADMIN_ASSISTANT") ? <Route index element={<RestaurantMaster />} /> :
            <Route index element={<Navigate to="/cuisine" />} />}
          <Route path="cuisine" element={<CuisineMaster />} />
          <Route path="item-recipe" element={<ItemMaster />} />
          <Route path="customization-recipe" element={<ItemMaster />} />
          <Route path="condiment-recipe" element={<ItemMaster />} />
          {(userRole && userRole !== "ADMIN_ASSISTANT") && <Route path="restaurant-employee" element={<RestuaurantEmployeeMaster />} />}
          {(userRole && userRole !== "ADMIN_ASSISTANT") && <Route path="otp" element={<OtpMaster />} />}
          <Route path="ingredient" element={<IngredientMaster />} />
          <Route path="user-admin" element={<UserAdminMaster />} />
          <Route path="brand" element={<BrandMaster />} />
          <Route path="unit-of-measurement" element={<UnitOfMeasurementMaster />} />
          <Route path="open-pdf/:id" element={<ViewPdf />} />
        </Route>
      )}
    </Routes>
  );
};

export default AppRoutes;
